import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseModalContainer, BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { VrstaIzostanka } from './vrsta-izostanka';

@Component({
  selector: 'yt-vrsta-izostanka-modal-update',
  templateUrl: './vrsta-izostanka-modal-update.component.html'
})
export class VrstaIzostankaModalUpdateComponent extends BaseModalUpdateComponent<VrstaIzostanka> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaIzostanka>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
   }

  ngOnInit() {
  }

}
